class CountdownTimer extends HTMLElement {
  connectedCallback() {
    this.end = Date.parse(this.dataset.end);
    if (Number.isNaN(this.end) || this.end <= Date.now()) {
      this.hideBar();
      return;
    }
    this.cells = {
      days: this.querySelector('[data-unit="days"]'),
      hours: this.querySelector('[data-unit="hours"]'),
      minutes: this.querySelector('[data-unit="minutes"]'),
      seconds: this.querySelector('[data-unit="seconds"]'),
    };
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  hideBar() {
    clearInterval(this.interval);
    const bar = this.closest('.countdown-bar');
    if (bar) bar.hidden = true;
  }

  tick() {
    let remaining = Math.floor((this.end - Date.now()) / 1000);
    if (remaining <= 0) {
      this.hideBar();
      return;
    }
    const days = Math.floor(remaining / 86400);
    remaining -= days * 86400;
    const hours = Math.floor(remaining / 3600);
    remaining -= hours * 3600;
    const minutes = Math.floor(remaining / 60);
    const seconds = remaining - minutes * 60;
    const values = { days, hours, minutes, seconds };
    Object.keys(this.cells).forEach((unit) => {
      if (this.cells[unit]) this.cells[unit].textContent = String(values[unit]).padStart(2, '0');
    });
  }
}

customElements.define('countdown-timer', CountdownTimer);
